/**
 * Which chrome a route gets (see DESIGN.md → Navigation model).
 *
 * - Public pages (signed out): header with the theme button, slim footer, no tab bar.
 * - Step flows: no tab bar (the step has its own Back link and sticky action) and no footer.
 * - Ride day and booking confirmation: tab bar on phones, never a footer.
 */
export const PUBLIC_PATHS = ['/', '/privacy', '/terms'];
export const PUBLIC_PREFIXES = ['/auth/'];

/** Wizard steps after the entry screen: they carry a sticky primary action and a Back link. */
export const STEP_ROUTES = [
  '/ride/route',
  '/ride/party',
  '/ride/matches',
  '/ride/verify',
  '/drive/profile',
  '/drive/verify',
  '/drive/events',
  '/drive/route',
  '/drive/summary',
];

/** Screens that never show a footer (in addition to the step routes). */
export const NO_FOOTER_PREFIXES = ['/ride/day/', '/drive/day/', '/ride/confirm/'];

export function isPublicRoute(pathname: string): boolean {
  return PUBLIC_PATHS.includes(pathname) || PUBLIC_PREFIXES.some((p) => pathname.startsWith(p));
}

export function isStepRoute(pathname: string): boolean {
  return STEP_ROUTES.includes(pathname);
}

export function isNoFooterRoute(pathname: string): boolean {
  return isStepRoute(pathname) || NO_FOOTER_PREFIXES.some((p) => pathname.startsWith(p));
}
